import { render, staticRenderFns } from "./buildingManagement.vue?vue&type=template&id=4e2f6bbf&"
import script from "./buildingManagement.vue?vue&type=script&lang=js&"
export * from "./buildingManagement.vue?vue&type=script&lang=js&"
import style0 from "./buildingManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports